import { gql } from '@apollo/client';

const ADMIN_CONSOLE_ACHIEVEMENT_FRAGMENT = gql`
  fragment AdminConsoleAchievement on VOLUNTEER_AchievementType {
    achievementId
    name
    description
    metric
    reportFieldId
    isEnabled
    isDiscoverable
    showProgress
    customMessage
    levels {
      achievementLevelId
      name
      threshold
      position
      liveFrom
      badgeDesign
      badgeImageUrl
      certificateTemplate {
        certificateTemplateId
      }
    }
  }
`;

export const GET_ADMIN_CONSOLE_ACHIEVEMENTS = gql`
  query GetAdminConsoleAchievements {
    vm {
      achievements {
        ...AdminConsoleAchievement
      }
      certificateTemplates {
        certificateTemplateId
        name
      }
      reportTypes {
        reportTypeId
        name
        dateDeactivated
        items {
          ... on VOLUNTEER_ReportTypeFieldType {
            reportTypeItemId
            dateAdded
            dateRemoved
            field {
              ... on VOLUNTEER_NumericFieldType {
                fieldId
                name
              }
            }
          }
        }
      }
    }
  }
  ${ADMIN_CONSOLE_ACHIEVEMENT_FRAGMENT}
`;

export const GET_ACHIEVEMENT_BACKFILL_COUNT = gql`
  query GetAchievementBackfillCount($achievementId: String!) {
    vm {
      achievement(achievementId: $achievementId) {
        achievementId
        backfillCount
      }
    }
  }
`;
